msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-09 18:50+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"

#. js-lingui-explicit-id
#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Completar tarea como:"
msgstr "Completar tarea como:"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento guardado"
msgstr "Memento guardado"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento creado"
msgstr "Memento creado"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento marcado como completado"
msgstr "Memento marcado como completado"

#. js-lingui-explicit-id
#: src/pages/Mementos/hooks/useMementoActions.js
msgid "Memento eliminado"
msgstr "Memento eliminado"

#: src/pages/Settings/partials/OptionItem/OptionItem.jsx
msgid "- Menos información"
msgstr "- Menos información"

#: src/pages/Onboarding/GroupView.jsx
msgid "¡Bien hecho!"
msgstr "¡Bien hecho!"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "¡Copiado!"
msgstr "¡Copiado!"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "¡Nada pendiente para esta semana!"
msgstr "¡Nada pendiente para esta semana!"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "¡No tienes tareas pendientes!"
msgstr "¡No tienes tareas pendientes!"

#: src/pages/Mementos/tabs/MementosContributions/MementosContributions.jsx
msgid "¡Todavía no hay contribuciones!"
msgstr "¡Todavía no hay contribuciones!"

#: src/pages/Mementos/TasksDashboard/partials/StatCard/StatCard.jsx
msgid "¡Todo bien!"
msgstr "¡Todo bien!"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "¿No llega el email? Revisa la carpeta de spam."
msgstr "¿No llega el email? Revisa la carpeta de spam."

#: src/pages/Login/partials/EmailStep.jsx
msgid "¿No tienes cuenta? Regístrate"
msgstr "¿No tienes cuenta? Regístrate"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "¿Qué es esto?"
msgstr "¿Qué es esto?"

#: src/pages/Onboarding/GroupView.jsx
msgid "¿Qué es un espacio?"
msgstr "¿Qué es un espacio?"

#: src/pages/Dashboard/DashboardView.jsx
msgid "¿Qué quieres hacer hoy?"
msgstr "¿Qué quieres hacer hoy?"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "¿Seguro que quieres eliminar este gasto? Esta acción no se puede deshacer."
msgstr "¿Seguro que quieres eliminar este gasto? Esta acción no se puede deshacer."

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "¿Seguro que quieres eliminar este grupo? Se borrarán todos los gastos asociados."
msgstr "¿Seguro que quieres eliminar este grupo? Se borrarán todos los gastos asociados."

#: src/pages/Recipes/RecipeShareView.jsx
msgid "¿Te gusta esta receta? Crea las tuyas gratis en Economos."
msgstr "¿Te gusta esta receta? Crea las tuyas gratis en Economos."

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "(tú)"
msgstr "(tú)"

#: src/pages/Legal/PrivacyView.jsx
msgid "[PENDIENTE: razón social, NIF y domicilio social del titular] (en adelante, \"el responsable\"), correo de contacto: [PENDIENTE: privacy@…]."
msgstr "[PENDIENTE: razón social, NIF y domicilio social del titular] (en adelante, \"el responsable\"), correo de contacto: [PENDIENTE: privacy@…]."

#. placeholder {0}: filteredHouseItems.length
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+%C3%ADtem+restante%7D+other+%7B%23+%C3%ADtems+restantes%7D%7D&pluralize_on=0
#: src/pages/Items/tabs/Items/Items.jsx
msgid "# ítem restante"
msgid_plural "# ítems restantes"
msgstr[0] "# ítem restante"
msgstr[1] "# ítems restantes"

#. placeholder {0}: items.length
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+%C3%ADtem%7D+other+%7B%23+%C3%ADtems%7D%7D&pluralize_on=0
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "# ítem"
msgid_plural "# ítems"
msgstr[0] "# ítem"
msgstr[1] "# ítems"

#. placeholder {0}: (recipe.servings ?? 0) * numericMultiplier
#. placeholder {0}: recipe.servings
#. placeholder {0}: recipe.servings * numericMultiplier
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+raci%C3%B3n%7D+other+%7B%23+raciones%7D%7D&pluralize_on=0
#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "# ración"
msgid_plural "# raciones"
msgstr[0] "# ración"
msgstr[1] "# raciones"

#. placeholder {0}: group.users?.length ?? 0
#. js-lingui:icu=%7B0%2C+plural%2C+one+%7B%23+usuario%7D+other+%7B%23+usuarios%7D%7D&pluralize_on=0
#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "# usuario"
msgid_plural "# usuarios"
msgstr[0] "# usuario"
msgstr[1] "# usuarios"

#. placeholder {0}: expensesPerUser.toFixed(2)
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "{0} € por persona"
msgstr "{0} € por persona"

#. placeholder {0}: list.length
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "{0} recomendaciones"
msgstr "{0} recomendaciones"

#. js-lingui:icu=%7Bcount%2C+plural%2C+one+%7Btarea%7D+other+%7Btareas%7D%7D&pluralize_on=count
#: src/pages/Mementos/TasksDashboard/partials/CompletedStatCard/CompletedStatCard.jsx
#: src/pages/Mementos/TasksDashboard/partials/StatCard/StatCard.jsx
msgid "tarea"
msgid_plural "tareas"
msgstr[0] "tarea"
msgstr[1] "tareas"

#. js-lingui:icu=%7BdaysUntilEndOfMonth%2C+plural%2C+one+%7B%23+d%C3%ADa+restante%7D+other+%7B%23+d%C3%ADas+restantes%7D%7D&pluralize_on=daysUntilEndOfMonth
#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "# día restante"
msgid_plural "# días restantes"
msgstr[0] "# día restante"
msgstr[1] "# días restantes"

#. js-lingui:icu=%7BmovementsToCreateCount%2C+plural%2C+one+%7BSe+crear%C3%A1+%23+movimiento%7D+other+%7BSe+crear%C3%A1n+%23+movimientos%7D%7D&pluralize_on=movementsToCreateCount
#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Se creará # movimiento"
msgid_plural "Se crearán # movimientos"
msgstr[0] "Se creará # movimiento"
msgstr[1] "Se crearán # movimientos"

#. js-lingui:icu=%7BnewCount%2C+plural%2C+one+%7BCrear+%23+%C3%ADtem%7D+other+%7BCrear+%23+%C3%ADtems%7D%7D&pluralize_on=newCount
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Crear # ítem"
msgid_plural "Crear # ítems"
msgstr[0] "Crear # ítem"
msgstr[1] "Crear # ítems"

#. js-lingui:icu=%7BnewCount%2C+plural%2C+one+%7BCrear+%23+tarea%7D+other+%7BCrear+%23+tareas%7D%7D&pluralize_on=newCount
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Crear # tarea"
msgid_plural "Crear # tareas"
msgstr[0] "Crear # tarea"
msgstr[1] "Crear # tareas"

#: src/pages/Settings/partials/OptionItem/OptionItem.jsx
msgid "+ Más información"
msgstr "+ Más información"

#: src/pages/Items/ItemsView.jsx
msgid "📚 Categorías"
msgstr "📚 Categorías"

#: src/pages/Mementos/MementosView.jsx
msgid "📚 Tareas"
msgstr "📚 Tareas"

#: src/pages/Items/ItemsView.jsx
msgid "📦 Ítems"
msgstr "📦 Ítems"

#: src/pages/Items/ItemsView.jsx
msgid "🔮 Predicciones"
msgstr "🔮 Predicciones"

#: src/pages/Mementos/MementosView.jsx
msgid "🤝 Contribuciones"
msgstr "🤝 Contribuciones"

#: src/pages/Legal/TermsView.jsx
msgid "1. Objeto"
msgstr "1. Objeto"

#: src/pages/Legal/CookiesView.jsx
msgid "1. Qué son las cookies"
msgstr "1. Qué son las cookies"

#: src/pages/Legal/PrivacyView.jsx
msgid "1. Responsable del tratamiento"
msgstr "1. Responsable del tratamiento"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "10 años"
msgstr "10 años"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "12 meses"
msgstr "12 meses"

#: src/pages/Legal/CookiesView.jsx
msgid "2. Cookies que utilizamos"
msgstr "2. Cookies que utilizamos"

#: src/pages/Legal/TermsView.jsx
msgid "2. Cuenta de usuario"
msgstr "2. Cuenta de usuario"

#: src/pages/Legal/PrivacyView.jsx
msgid "2. Datos que tratamos"
msgstr "2. Datos que tratamos"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "3 años"
msgstr "3 años"

#: src/pages/Legal/CookiesView.jsx
msgid "3. Almacenamiento local (localStorage)"
msgstr "3. Almacenamiento local (localStorage)"

#: src/pages/Legal/TermsView.jsx
msgid "3. Espacios colaborativos"
msgstr "3. Espacios colaborativos"

#: src/pages/Legal/PrivacyView.jsx
msgid "3. Finalidad y base jurídica"
msgstr "3. Finalidad y base jurídica"

#: src/pages/Legal/CookiesView.jsx
msgid "4. Cookies no exentas (con tu consentimiento)"
msgstr "4. Cookies no exentas (con tu consentimiento)"

#: src/pages/Legal/PrivacyView.jsx
msgid "4. Destinatarios y transferencias internacionales"
msgstr "4. Destinatarios y transferencias internacionales"

#: src/pages/Legal/TermsView.jsx
msgid "4. Propiedad intelectual"
msgstr "4. Propiedad intelectual"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "5 años"
msgstr "5 años"

#: src/pages/Legal/CookiesView.jsx
msgid "5. Cómo gestionar tu consentimiento"
msgstr "5. Cómo gestionar tu consentimiento"

#: src/pages/Legal/PrivacyView.jsx
msgid "5. Conservación"
msgstr "5. Conservación"

#: src/pages/Legal/TermsView.jsx
msgid "5. Disponibilidad y limitación de responsabilidad"
msgstr "5. Disponibilidad y limitación de responsabilidad"

#: src/pages/Legal/TermsView.jsx
msgid "6. Condiciones de contratación (pagos)"
msgstr "6. Condiciones de contratación (pagos)"

#: src/pages/Legal/PrivacyView.jsx
msgid "6. Tus derechos"
msgstr "6. Tus derechos"

#: src/pages/Legal/PrivacyView.jsx
msgid "7. Cookies"
msgstr "7. Cookies"

#: src/pages/Legal/TermsView.jsx
msgid "7. Modificaciones y extinción"
msgstr "7. Modificaciones y extinción"

#: src/pages/Legal/TermsView.jsx
msgid "8. Ley aplicable"
msgstr "8. Ley aplicable"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "a"
msgstr "a"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Abundante"
msgstr "Abundante"

#: src/pages/Login/LoginView.jsx
msgid "Accede a Economos"
msgstr "Accede a Economos"

#: src/pages/Settings/Settings.jsx
msgid "Aceptadas"
msgstr "Aceptadas"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Aceptar"
msgstr "Aceptar"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Aceptar cookies"
msgstr "Aceptar cookies"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Aceptar invitación"
msgstr "Aceptar invitación"

#: src/pages/Register/RegisterView.jsx
msgid "Acepto los <0>términos y condiciones</0> y la <1>política de privacidad</1>."
msgstr "Acepto los <0>términos y condiciones</0> y la <1>política de privacidad</1>."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Activar después de"
msgstr "Activar después de"

#. placeholder {0}: dayjs(group.lastActivity).fromNow()
#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Activo {0}"
msgstr "Activo {0}"

#. placeholder {0}: dayjs(usageOverview.currentPeriodEnd).format("DD/MM/YYYY")
#: src/pages/Usage/UsageView.jsx
msgid "Activo hasta el {0}"
msgstr "Activo hasta el {0}"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockPopover/StockPopover.jsx
msgid "Actualiza el stock en tu despensa y se contará como una compra."
msgstr "Actualiza el stock en tu despensa y se contará como una compra."

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Administrador"
msgstr "Administrador"

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Agotado"
msgstr "Agotado"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Ahora podrás crear uno nuevo a partir del duplicado"
msgstr "Ahora podrás crear uno nuevo a partir del duplicado"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Ajustes"
msgstr "Ajustes"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Alguien ha editado esta tarea"
msgstr "Alguien ha editado esta tarea"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Alguien ha editado este ítem"
msgstr "Alguien ha editado este ítem"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Alguien ha editado este movimiento"
msgstr "Alguien ha editado este movimiento"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Alimentos básicos"
msgstr "Alimentos básicos"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añade al menos un ingrediente"
msgstr "Añade al menos un ingrediente"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añade al menos un paso"
msgstr "Añade al menos un paso"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Añade al menos un usuario"
msgstr "Añade al menos un usuario"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Añade una descripción (opcional)"
msgstr "Añade una descripción (opcional)"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Añade usuarios al grupo para crear gastos"
msgstr "Añade usuarios al grupo para crear gastos"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añadir ingrediente"
msgstr "Añadir ingrediente"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Añadir paso"
msgstr "Añadir paso"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Análisis"
msgstr "Análisis"

#: src/pages/Economos/Movements/partials/SwipeableEconomosItem/SwipeableEconomosItem.jsx
msgid "Analizar"
msgstr "Analizar"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Anclado"
msgstr "Anclado"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Anclar ítems"
msgstr "Anclar ítems"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Anual"
msgstr "Anual"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
msgid "Aplicaciones"
msgstr "Aplicaciones"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Aplicar"
msgstr "Aplicar"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "Aplicar todo"
msgstr "Aplicar todo"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Apunta quién paga qué entre varias personas y salda las deudas de una sola vez."
msgstr "Apunta quién paga qué entre varias personas y salda las deudas de una sola vez."

#: src/components/common/ui/button/BackButton/BackButton.jsx
msgid "Atrás"
msgstr "Atrás"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Atrasadas"
msgstr "Atrasadas"

#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Aumenta tu límite actualizando al plan"
msgstr "Aumenta tu límite actualizando al plan"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Ayer"
msgstr "Ayer"

#: src/components/common/ui/feedback/HelpIcon/HelpIcon.jsx
msgid "Ayuda"
msgstr "Ayuda"

#: src/pages/Settings/Settings.jsx
msgid "Botón hamburguesa para el pulgar en versión móvil."
msgstr "Botón hamburguesa para el pulgar en versión móvil."

#: src/components/common/ui/combobox/CategoryCombobox.jsx
msgid "Busca categoría"
msgstr "Busca categoría"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Buscar"
msgstr "Buscar"

#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "Búsqueda"
msgstr "Búsqueda"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "cada {frequencyDays} días"
msgstr "cada {frequencyDays} días"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 2 meses"
msgstr "Cada 2 meses"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 2 semanas"
msgstr "Cada 2 semanas"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada 6 meses"
msgstr "Cada 6 meses"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada año"
msgstr "Cada año"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "cada día"
msgstr "cada día"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada mes"
msgstr "Cada mes"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Cada semana"
msgstr "Cada semana"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Calculadora"
msgstr "Calculadora"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/components/Crew/CrewMembers/CrewMembers.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Cancelar"
msgstr "Cancelar"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Cantidad"
msgstr "Cantidad"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Cantidad inválida"
msgstr "Cantidad inválida"

#: src/pages/Items/tabs/Categories/Categories.jsx
msgid "Categoría eliminada con éxito"
msgstr "Categoría eliminada con éxito"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Categorías"
msgstr "Categorías"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Cena, taxi, super..."
msgstr "Cena, taxi, super..."

#: src/pages/Login/LoginView.jsx
msgid "Cerrar"
msgstr "Cerrar"

#: src/Layouts/private/PrivateLayout.jsx
msgid "Cerrar menú"
msgstr "Cerrar menú"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "Cerrar sesión"
msgstr "Cerrar sesión"

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Cerrar sesión y reparar"
msgstr "Cerrar sesión y reparar"

#: src/pages/Mementos/TasksDashboard/partials/CompletedStatCard/CompletedStatCard.jsx
msgid "Completado hoy"
msgstr "Completado hoy"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Completar"
msgstr "Completar"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/CompleteTaskAsModal.jsx
msgid "Completar tarea como:"
msgstr "Completar tarea como:"

#: src/pages/Settings/Settings.jsx
msgid "Completar tareas inactivas"
msgstr "Completar tareas inactivas"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Con emojis"
msgstr "Con emojis"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Concepto"
msgstr "Concepto"

#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Items/tabs/Items/partials/EmptyItems/EmptyItems.jsx
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Configuración inicial"
msgstr "Configuración inicial"

#: src/pages/Settings/Settings.jsx
msgid "Consentimiento de cookies"
msgstr "Consentimiento de cookies"

#: src/pages/Legal/PrivacyView.jsx
msgid "Conservamos tus datos mientras exista tu cuenta y, tras su eliminación, durante los plazos de prescripción legal aplicables. La prueba de consentimiento de cookies se conserva como máximo 12 meses desde la última decisión, o hasta que la retires."
msgstr "Conservamos tus datos mientras exista tu cuenta y, tras su eliminación, durante los plazos de prescripción legal aplicables. La prueba de consentimiento de cookies se conserva como máximo 12 meses desde la última decisión, o hasta que la retires."

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Contacto"
msgstr "Contacto"

#: src/pages/Login/partials/EmailStep.jsx
#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Continuar"
msgstr "Continuar"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Contribución editada"
msgstr "Contribución editada"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Contribución eliminada"
msgstr "Contribución eliminada"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Contribuciones"
msgstr "Contribuciones"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Controla tus finanzas domésticas. Registra ingresos, gastos y visualiza hábitos de consumo."
msgstr "Controla tus finanzas domésticas. Registra ingresos, gastos y visualiza hábitos de consumo."

#: src/pages/Legal/CookiesView.jsx
msgid "Cookie"
msgstr "Cookie"

#: src/pages/Settings/Settings.jsx
msgid "Cookies"
msgstr "Cookies"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Copiado"
msgstr "Copiado"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Copiar"
msgstr "Copiar"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Copiar enlace"
msgstr "Copiar enlace"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Crea tu primera lista para empezar a registrar movimientos"
msgstr "Crea tu primera lista para empezar a registrar movimientos"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creadas {created} de {total} tareas"
msgstr "Creadas {created} de {total} tareas"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creados {created} de {total} ítems"
msgstr "Creados {created} de {total} ítems"

#. placeholder {0}: progress.done
#. placeholder {1}: progress.total
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creando ítems... {0}/{1}"
msgstr "Creando ítems... {0}/{1}"

#. placeholder {0}: progress.done
#. placeholder {1}: progress.total
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Creando tareas... {0}/{1}"
msgstr "Creando tareas... {0}/{1}"

#: src/utils/hooks/usePolymorphicData.jsx
msgid "Crear"
msgstr "Crear"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Crear categoría"
msgstr "Crear categoría"

#: src/pages/Home/HomeView.jsx
#: src/pages/Recipes/RecipeShareView.jsx
#: src/pages/Register/RegisterView.jsx
msgid "Crear cuenta"
msgstr "Crear cuenta"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Crear espacio"
msgstr "Crear espacio"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Crear grupo de gastos"
msgstr "Crear grupo de gastos"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Crear ítem"
msgstr "Crear ítem"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/EconomosListTabs.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Crear lista"
msgstr "Crear lista"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Crear memento"
msgstr "Crear memento"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Crear movimiento"
msgstr "Crear movimiento"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Crear receta"
msgstr "Crear receta"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Cualquiera con el enlace podrá ver esta receta"
msgstr "Cualquiera con el enlace podrá ver esta receta"

#: src/pages/Settings/Settings.jsx
msgid "Cuando se activen"
msgstr "Cuando se activen"

#: src/pages/Legal/TermsView.jsx
msgid "Cuando se activen los pagos, los planes de pago se contratarán en euros (EUR) con IVA incluido cuando proceda, mostrando antes del pago el precio total y las características de cada plan. Como consumidor, dispondrás de 14 días naturales para desistir del contrato sin justificación, conforme al TRLGDCU. Esta sección entrará en vigor con la activación de los pagos."
msgstr "Cuando se activen los pagos, los planes de pago se contratarán en euros (EUR) con IVA incluido cuando proceda, mostrando antes del pago el precio total y las características de cada plan. Como consumidor, dispondrás de 14 días naturales para desistir del contrato sin justificación, conforme al TRLGDCU. Esta sección entrará en vigor con la activación de los pagos."

#: src/pages/Register/RegisterView.jsx
msgid "Cuenta creada con éxito"
msgstr "Cuenta creada con éxito"

#: src/pages/Login/LoginView.jsx
msgid "Cuenta no encontrada"
msgstr "Cuenta no encontrada"

#: src/pages/Legal/PrivacyView.jsx
msgid "Cumplir obligaciones legales y defender reclamaciones: interés legítimo y obligación legal (art. 6.1.c y 6.1.f RGPD)."
msgstr "Cumplir obligaciones legales y defender reclamaciones: interés legítimo y obligación legal (art. 6.1.c y 6.1.f RGPD)."

#: src/pages/Settings/Settings.jsx
msgid "Dashboard de tareas"
msgstr "Dashboard de tareas"

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de cuenta: nombre de usuario, correo electrónico e idioma."
msgstr "Datos de cuenta: nombre de usuario, correo electrónico e idioma."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de diagnóstico: si aceptas las cookies no exentas, errores y rendimiento de la aplicación (Bugsnag), que pueden incluir tu identificador, correo y nombre de usuario."
msgstr "Datos de diagnóstico: si aceptas las cookies no exentas, errores y rendimiento de la aplicación (Bugsnag), que pueden incluir tu identificador, correo y nombre de usuario."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos de uso: los contenidos que creas (espacios, listas, tareas, movimientos) pertenecen a tu cuenta y a los espacios donde colaboras."
msgstr "Datos de uso: los contenidos que creas (espacios, listas, tareas, movimientos) pertenecen a tu cuenta y a los espacios donde colaboras."

#: src/pages/Legal/PrivacyView.jsx
msgid "Datos técnicos: registramos la prueba de consentimiento de cookies (identificador anónimo, fecha, versión de la política y decisión). No almacenamos IP ni User-Agent con ese registro."
msgstr "Datos técnicos: registramos la prueba de consentimiento de cookies (identificador anónimo, fecha, versión de la política y decisión). No almacenamos IP ni User-Agent con ese registro."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "De esta forma, los ítems que actualmente estén con stock"
msgstr "De esta forma, los ítems que actualmente estén con stock"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Debe ser mayor que 0"
msgstr "Debe ser mayor que 0"

#: src/pages/Register/RegisterView.jsx
msgid "Debes aceptar los términos y la política de privacidad"
msgstr "Debes aceptar los términos y la política de privacidad"

#: src/pages/Legal/TermsView.jsx
msgid "Debes facilitar datos veraces y mantener la confidencialidad de tu cuenta. Eres responsable de la actividad realizada con ella. La mínima edad de uso es 14 años; los menores de 18 necesitan autorización de padre, madre o tutor legal."
msgstr "Debes facilitar datos veraces y mantener la confidencialidad de tu cuenta. Eres responsable de la actividad realizada con ella. La mínima edad de uso es 14 años; los menores de 18 necesitan autorización de padre, madre o tutor legal."

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Dentro de {parentDelayDays} {parentDelayDays, plural, one {día} other {días}}"
msgstr "Dentro de {parentDelayDays} {parentDelayDays, plural, one {día} other {días}}"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Desactivada"
msgstr "Desactivada"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Describe el paso"
msgstr "Describe el paso"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Descripción"
msgstr "Descripción"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Desde"
msgstr "Desde"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Despensa"
msgstr "Despensa"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Destino"
msgstr "Destino"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Día {label}"
msgstr "Día {label}"

#: src/pages/Legal/PrivacyView.jsx
msgid "Diagnóstico de errores y rendimiento: tu consentimiento (art. 6.1.a RGPD), que puedes retirar en cualquier momento desde Ajustes."
msgstr "Diagnóstico de errores y rendimiento: tu consentimiento (art. 6.1.a RGPD), que puedes retirar en cualquier momento desde Ajustes."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "días"
msgstr "días"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Días"
msgstr "Días"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Dinero"
msgstr "Dinero"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Dividido entre"
msgstr "Dividido entre"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Duplicar"
msgstr "Duplicar"

#: src/pages/Legal/CookiesView.jsx
msgid "Duración"
msgstr "Duración"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Editar"
msgstr "Editar"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Editar categoría"
msgstr "Editar categoría"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionItem/ContributionItem.jsx
msgid "Editar contribución"
msgstr "Editar contribución"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Editar espacio"
msgstr "Editar espacio"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Editar gasto"
msgstr "Editar gasto"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Editar grupo"
msgstr "Editar grupo"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Editar grupo de gastos"
msgstr "Editar grupo de gastos"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Editar ítem"
msgstr "Editar ítem"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Editar lista"
msgstr "Editar lista"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Editar memento"
msgstr "Editar memento"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Editar movimiento"
msgstr "Editar movimiento"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Editar receta"
msgstr "Editar receta"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Editar serie"
msgstr "Editar serie"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Ej. Alquiler"
msgstr "Ej. Alquiler"

#: src/pages/MagicLink/MagicLink.jsx
msgid "El código no es válido o ha caducado."
msgstr "El código no es válido o ha caducado."

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "El enlace de invitación no es válido"
msgstr "El enlace de invitación no es válido"

#: src/pages/Register/RegisterView.jsx
msgid "El nombre debe tener al menos 3 caracteres"
msgstr "El nombre debe tener al menos 3 caracteres"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "El nombre es obligatorio"
msgstr "El nombre es obligatorio"

#: src/pages/Register/RegisterView.jsx
msgid "El nombre no puede superar los 64 caracteres"
msgstr "El nombre no puede superar los 64 caracteres"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "El origen y el destino no pueden ser la misma lista"
msgstr "El origen y el destino no pueden ser la misma lista"

#: src/pages/Legal/TermsView.jsx
msgid "El servicio se organiza en espacios que puedes compartir con otras personas. Al invitar a alguien a un espacio, su contenido será visible para sus miembros según el rol asignado. No uses el servicio para contenidos ilícitos, y respeta los derechos de terceros."
msgstr "El servicio se organiza en espacios que puedes compartir con otras personas. Al invitar a alguien a un espacio, su contenido será visible para sus miembros según el rol asignado. No uses el servicio para contenidos ilícitos, y respeta los derechos de terceros."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "El sistema de predicciones utiliza los ítems comprados en los últimos 6 meses y calcula el promedio de días que hay entre compra y compra."
msgstr "El sistema de predicciones utiliza los ítems comprados en los últimos 6 meses y calcula el promedio de días que hay entre compra y compra."

#: src/pages/Settings/Settings.jsx
msgid "Elige si el dashboard de tareas muestra las de todos tus espacios o sólo las del seleccionado."
msgstr "Elige si el dashboard de tareas muestra las de todos tus espacios o sólo las del seleccionado."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Eliminar"
msgstr "Eliminar"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
msgid "Eliminar categoría"
msgstr "Eliminar categoría"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Eliminar contribución"
msgstr "Eliminar contribución"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Eliminar crew"
msgstr "Eliminar crew"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Eliminar espacio"
msgstr "Eliminar espacio"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar este y los siguientes"
msgstr "Eliminar este y los siguientes"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Eliminar gasto"
msgstr "Eliminar gasto"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Eliminar grupo"
msgstr "Eliminar grupo"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Eliminar ingrediente"
msgstr "Eliminar ingrediente"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Eliminar ítem"
msgstr "Eliminar ítem"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Eliminar lista"
msgstr "Eliminar lista"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Eliminar memento"
msgstr "Eliminar memento"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar movimiento"
msgstr "Eliminar movimiento"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Eliminar movimiento recurrente"
msgstr "Eliminar movimiento recurrente"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar movimientos"
msgstr "Eliminar movimientos"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Eliminar paso"
msgstr "Eliminar paso"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Eliminar receta"
msgstr "Eliminar receta"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar serie"
msgstr "Eliminar serie"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Eliminar serie de movimientos"
msgstr "Eliminar serie de movimientos"

#: src/components/common/ui/input/EmailInput.jsx
msgid "Email"
msgstr "Email"

#: src/pages/Login/partials/EmailStep.jsx
#: src/pages/Register/RegisterView.jsx
msgid "Email inválido"
msgstr "Email inválido"

#: src/pages/Login/LoginView.jsx
msgid "Email reenviado"
msgstr "Email reenviado"

#: src/components/common/ui/input/EmailInput.jsx
msgid "email@dominio.com"
msgstr "email@dominio.com"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 1 año"
msgstr "En 1 año"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 1 mes"
msgstr "En 1 mes"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 3 meses"
msgstr "En 3 meses"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "En 6 meses"
msgstr "En 6 meses"

#: src/pages/Settings/Settings.jsx
msgid "En versión móvil mostrará el selector de espacios en la parte superior en todo momento."
msgstr "En versión móvil mostrará el selector de espacios en la parte superior en todo momento."

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Enlace de invitación"
msgstr "Enlace de invitación"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Enlace público"
msgstr "Enlace público"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Entre 1 y 99 raciones"
msgstr "Entre 1 y 99 raciones"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/utils/common/api/handleApiResponse.jsx
msgid "Error"
msgstr "Error"

#: src/pages/Usage/UsageView.jsx
msgid "Error al cargar el uso."
msgstr "Error al cargar el uso."

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Error al crear la transferencia"
msgstr "Error al crear la transferencia"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Error desconocido"
msgstr "Error desconocido"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Escalar cantidades"
msgstr "Escalar cantidades"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Escribe aquí las etiquetas"
msgstr "Escribe aquí las etiquetas"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Escribe el nombre o enlaza un ítem"
msgstr "Escribe el nombre o enlaza un ítem"

#: src/components/common/ui/combobox/ComboboxBase/ComboboxBase.jsx
#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Recipes/RecipesView.jsx
msgid "Escribe para buscar"
msgstr "Escribe para buscar"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Escribe un nombre"
msgstr "Escribe un nombre"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Escribe una descripción"
msgstr "Escribe una descripción"

#: src/components/common/ui/datadisplay/Effort.jsx
msgid "esfuerzo"
msgstr "esfuerzo"

#: src/components/common/ui/datadisplay/Effort.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Esfuerzo"
msgstr "Esfuerzo"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Esfuerzo completado esta semana en el espacio seleccionado"
msgstr "Esfuerzo completado esta semana en el espacio seleccionado"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio creado con éxito"
msgstr "Espacio creado con éxito"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio eliminado con éxito"
msgstr "Espacio eliminado con éxito"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Espacio no encontrado"
msgstr "Espacio no encontrado"

#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacio renombrado con éxito"
msgstr "Espacio renombrado con éxito"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/CrewSelector.jsx
msgid "Espacios"
msgstr "Espacios"

#. placeholder {0}: crew.name
#. placeholder {0}: houseItem.name
#. placeholder {0}: memento.name
#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta acción eliminará \"{0}\" de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará \"{0}\" de forma permanente y no se podrá recuperar la información."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará el movimiento de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará el movimiento de forma permanente y no se podrá recuperar la información."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará este movimiento y todos los siguientes de la serie de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará este movimiento y todos los siguientes de la serie de forma permanente y no se podrá recuperar la información."

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Esta acción eliminará la contribución de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará la contribución de forma permanente y no se podrá recuperar la información."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Esta acción eliminará la lista y TODOS su movimientos de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará la lista y TODOS su movimientos de forma permanente y no se podrá recuperar la información."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Esta acción eliminará todos los movimientos de la serie de forma permanente y no se podrá recuperar la información."
msgstr "Esta acción eliminará todos los movimientos de la serie de forma permanente y no se podrá recuperar la información."

#. placeholder {0}: user.username
#. placeholder {1}: crew.name
#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Esta acción expulsará a <0>{0}</0> de tu espacio <1>{1}</1>.<2/>Podrás volver a enviarle un enlace de invitación para que vuelva a unirse."
msgstr "Esta acción expulsará a <0>{0}</0> de tu espacio <1>{1}</1>.<2/>Podrás volver a enviarle un enlace de invitación para que vuelva a unirse."

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Esta acción invalidará el enlace de invitación actual y creará uno nuevo. Todas las invitaciones enviadas y no aceptadas, dejarán de funcionar."
msgstr "Esta acción invalidará el enlace de invitación actual y creará uno nuevo. Todas las invitaciones enviadas y no aceptadas, dejarán de funcionar."

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta receta es privada"
msgstr "Esta receta es privada"

#: src/pages/Recipes/RecipeDetail.jsx
msgid "Esta receta es pública"
msgstr "Esta receta es pública"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Esta semana"
msgstr "Esta semana"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Estadísticas"
msgstr "Estadísticas"

#: src/pages/Settings/Settings.jsx
msgid "Estado actual: {consentStatus}. Puedes reabrir el aviso de cookies para cambiar tu decisión en cualquier momento."
msgstr "Estado actual: {consentStatus}. Puedes reabrir el aviso de cookies para cambiar tu decisión en cualquier momento."

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Este año"
msgstr "Este año"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Este campo es obligatorio"
msgstr "Este campo es obligatorio"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Este y los siguientes"
msgstr "Este y los siguientes"

#: src/pages/Legal/TermsView.jsx
msgid "Estos términos regulan el acceso y uso de la aplicación (en adelante, \"el servicio\"), prestada por [PENDIENTE: razón social, NIF y domicilio del titular]. Registrarte implica aceptarlos."
msgstr "Estos términos regulan el acceso y uso de la aplicación (en adelante, \"el servicio\"), prestada por [PENDIENTE: razón social, NIF y domicilio del titular]. Registrarte implica aceptarlos."

#: src/pages/Legal/TermsView.jsx
msgid "Estos términos se rigen por la legislación española. Para consumidores, será competente la jurisdicción de su domicilio. Para otras cuestiones, ver nuestra <0>política de privacidad</0>."
msgstr "Estos términos se rigen por la legislación española. Para consumidores, será competente la jurisdicción de su domicilio. Para otras cuestiones, ver nuestra <0>política de privacidad</0>."

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Etiqueta que indica el inicio del mes"
msgstr "Etiqueta que indica el inicio del mes"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Etiquetas"
msgstr "Etiquetas"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
msgid "Etiquetas relevantes"
msgstr "Etiquetas relevantes"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Evolución"
msgstr "Evolución"

#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Dashboard/DashboardView.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Experimentos"
msgstr "Experimentos"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Expulsar"
msgstr "Expulsar"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Expulsar miembro"
msgstr "Expulsar miembro"

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Fecha"
msgstr "Fecha"

#: src/pages/Legal/CookiesView.jsx
msgid "Finalidad"
msgstr "Finalidad"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Frecuencia (días)"
msgstr "Frecuencia (días)"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Gasto acumulado"
msgstr "Gasto acumulado"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Gasto hasta ahora"
msgstr "Gasto hasta ahora"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Gasto total del mes"
msgstr "Gasto total del mes"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Gastos"
msgstr "Gastos"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Gastos compartidos"
msgstr "Gastos compartidos"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Gastos:"
msgstr "Gastos:"

#: src/pages/Usage/UsageView.jsx
msgid "General"
msgstr "General"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Gestiona tu despensa. Lleva inventario de productos y genera listas de compra automáticamente."
msgstr "Gestiona tu despensa. Lleva inventario de productos y genera listas de compra automáticamente."

#: src/pages/Settings/Settings.jsx
msgid "Gestionar cookies"
msgstr "Gestionar cookies"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Gestionar miembros"
msgstr "Gestionar miembros"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Gestionar miembros del espacio"
msgstr "Gestionar miembros del espacio"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Gracias"
msgstr "Gracias"

#: src/pages/Home/HomeView.jsx
msgid "Gratis, sin contraseña y listo en 10 segundos."
msgstr "Gratis, sin contraseña y listo en 10 segundos."

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Guarda tus recetas y tenlas siempre a mano cuando cocines."
msgstr "Guarda tus recetas y tenlas siempre a mano cuando cocines."

#: src/pages/Legal/CookiesView.jsx
msgid "Guardamos en el almacenamiento local de tu navegador datos técnicos necesarios para la app (preferencias de interfaz, idioma, espacio seleccionado, prueba de tu consentimiento y un identificador anónimo de visitante). No se comparten con terceros."
msgstr "Guardamos en el almacenamiento local de tu navegador datos técnicos necesarios para la app (preferencias de interfaz, idioma, espacio seleccionado, prueba de tu consentimiento y un identificador anónimo de visitante). No se comparten con terceros."

#: src/utils/hooks/usePolymorphicData.jsx
msgid "Guardar"
msgstr "Guardar"

#: src/utils/common/api/handleApiResponse.jsx
msgid "Ha ocurrido un error desconocido"
msgstr "Ha ocurrido un error desconocido"

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Ha ocurrido un error inesperado"
msgstr "Ha ocurrido un error inesperado"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Hace {delayDays} {delayDays, plural, one {día} other {días}}"
msgstr "Hace {delayDays} {delayDays, plural, one {día} other {días}}"

#. placeholder {0}: item.used
#. placeholder {1}: item.limit
#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Has usado {0} de {1} en total"
msgstr "Has usado {0} de {1} en total"

#. placeholder {0}: item.used
#. placeholder {1}: item.limit
#: src/components/common/UsageLimit/UsageLimit.jsx
msgid "Has usado {0} de {1} este mes"
msgstr "Has usado {0} de {1} este mes"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Hasta"
msgstr "Hasta"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Hemos enviado un enlace temporal para iniciar sesión.<0/>Por favor, revisa la bandeja de entrada de <1>{email}</1>.<2/>Caduca en 2 minutos."
msgstr "Hemos enviado un enlace temporal para iniciar sesión.<0/>Por favor, revisa la bandeja de entrada de <1>{email}</1>.<2/>Caduca en 2 minutos."

#: src/pages/Repair/RepairView.jsx
msgid "Herramienta de reparación"
msgstr "Herramienta de reparación"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Horas"
msgstr "Horas"

#: src/components/common/ui/dates/Datepicker.jsx
#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Hoy"
msgstr "Hoy"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Indica el tiempo"
msgstr "Indica el tiempo"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Indica la unidad"
msgstr "Indica la unidad"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ingrediente"
msgstr "Ingrediente"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ingredientes"
msgstr "Ingredientes"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Ingredientes para"
msgstr "Ingredientes para"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Ingresos"
msgstr "Ingresos"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Ingresos:"
msgstr "Ingresos:"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Inicio"
msgstr "Inicio"

#: src/pages/Settings/Settings.jsx
msgid "Interfaz"
msgstr "Interfaz"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Introduce un importe mayor que 0"
msgstr "Introduce un importe mayor que 0"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Introduce un nombre"
msgstr "Introduce un nombre"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Introducir código manualmente"
msgstr "Introducir código manualmente"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Invitación a espacio"
msgstr "Invitación a espacio"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Ítem de despensa (opcional)"
msgstr "Ítem de despensa (opcional)"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Ítem eliminado"
msgstr "Ítem eliminado"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Ítems"
msgstr "Ítems"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "La compra ha sido registrada con éxito"
msgstr "La compra ha sido registrada con éxito"

#. placeholder {0}: _pred?.daysSinceMostRecentEvent ?? "¿?"
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "La última compra fue hace {0} días."
msgstr "La última compra fue hace {0} días."

#: src/pages/Legal/CookiesView.jsx
msgid "Las cookies son pequeños archivos que se guardan en tu navegador. Usamos cookies técnicas estrictamente necesarias para que la aplicación funcione, que no requieren consentimiento según el art. 22.2 LSSI, y una cookie no exenta (diagnóstico de errores) que solo se activa si la aceptas."
msgstr "Las cookies son pequeños archivos que se guardan en tu navegador. Usamos cookies técnicas estrictamente necesarias para que la aplicación funcione, que no requieren consentimiento según el art. 22.2 LSSI, y una cookie no exenta (diagnóstico de errores) que solo se activa si la aceptas."

#: src/pages/Items/tabs/Items/partials/HouseItem/partials/Stock.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Limitado"
msgstr "Limitado"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Limpiar"
msgstr "Limpiar"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Limpiar valor"
msgstr "Limpiar valor"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Limpieza"
msgstr "Limpieza"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Lista"
msgstr "Lista"

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Lista de meses"
msgstr "Lista de meses"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Listas de dinero"
msgstr "Listas de dinero"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Los grupos sin actividad durante 14 días se eliminarán automáticamente."
msgstr "Los grupos sin actividad durante 14 días se eliminarán automáticamente."

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Mañana"
msgstr "Mañana"

#: src/pages/Legal/CookiesView.jsx
msgid "Mantener tu sesión iniciada de forma segura."
msgstr "Mantener tu sesión iniciada de forma segura."

#: src/pages/Legal/TermsView.jsx
msgid "Mantienes la propiedad de los contenidos que creas. Te concedemos una licencia limitada para usar el servicio conforme a estos términos. La marca, el software y el diseño del servicio son propiedad del titular o de sus licenciantes."
msgstr "Mantienes la propiedad de los contenidos que creas. Te concedemos una licencia limitada para usar el servicio conforme a estos términos. La marca, el software y el diseño del servicio son propiedad del titular o de sus licenciantes."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Marcar como agotado tras"
msgstr "Marcar como agotado tras"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Marcar como:"
msgstr "Marcar como:"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Más info"
msgstr "Más info"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Mascotas y plantas"
msgstr "Mascotas y plantas"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Máximo 48 horas"
msgstr "Máximo 48 horas"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Mayor gasto"
msgstr "Mayor gasto"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Media al mes"
msgstr "Media al mes"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media diaria"
msgstr "Media diaria"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media mensual"
msgstr "Media mensual"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "Media por movimiento"
msgstr "Media por movimiento"

#: src/pages/Usage/UsageView.jsx
msgid "Mejora a <0/> para aumentar tus límites."
msgstr "Mejora a <0/> para aumentar tus límites."

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Mensual"
msgstr "Mensual"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Mes actual"
msgstr "Mes actual"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Mes anterior"
msgstr "Mes anterior"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Miembro"
msgstr "Miembro"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Miembro expulsado con éxito"
msgstr "Miembro expulsado con éxito"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Miembros"
msgstr "Miembros"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Minutos"
msgstr "Minutos"

#: src/pages/Items/tabs/Items/Items.jsx
#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockPopover/StockPopover.jsx
msgid "Modo compra"
msgstr "Modo compra"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Módulos"
msgstr "Módulos"

#. placeholder {0}: filteredHouseCategories.length
#. placeholder {0}: filteredHouseItems.length
#. placeholder {1}: houseCategories.length
#. placeholder {1}: houseItems.length
#: src/pages/Items/tabs/Categories/Categories.jsx
#: src/pages/Items/tabs/Items/Items.jsx
msgid "Mostrando {0} de {1} resultados"
msgstr "Mostrando {0} de {1} resultados"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar"
msgstr "Mostrar"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar a la derecha"
msgstr "Mostrar a la derecha"

#: src/pages/Settings/Settings.jsx
msgid "Mostrar a la izquierda"
msgstr "Mostrar a la izquierda"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Mostrar ingresos"
msgstr "Mostrar ingresos"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Mostrar ítems con stock limitado"
msgstr "Mostrar ítems con stock limitado"

#: src/pages/Settings/Settings.jsx
msgid "Mostrará un botón como este <0/> en la esquina inferior de la pantalla, para abrir el menú lateral de forma más fácil con el dedo pulgar."
msgstr "Mostrará un botón como este <0/> en la esquina inferior de la pantalla, para abrir el menú lateral de forma más fácil con el dedo pulgar."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento duplicado"
msgstr "Movimiento duplicado"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento editado"
msgstr "Movimiento editado"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimiento eliminado"
msgstr "Movimiento eliminado"

#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Movimiento recurrente"
msgstr "Movimiento recurrente"

#: src/pages/Economos/Movements/partials/EconomosApps/EconomosApps.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Movimientos"
msgstr "Movimientos"

#: src/components/common/UsageLimit/usageUtils.jsx
msgid "Movimientos / mes"
msgstr "Movimientos / mes"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Movimientos al mes"
msgstr "Movimientos al mes"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Movimientos eliminados"
msgstr "Movimientos eliminados"

#: src/pages/Onboarding/GroupView.jsx
msgid "Muéstrame cómo"
msgstr "Muéstrame cómo"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Nada encontrado"
msgstr "Nada encontrado"

#: src/components/common/ui/combobox/ComboboxBase/ComboboxBase.jsx
msgid "Nada seleccionado"
msgstr "Nada seleccionado"

#: src/App.jsx
msgid "Necesitas iniciar sesión"
msgstr "Necesitas iniciar sesión"

#: src/pages/Items/tabs/Categories/HouseItemCategory/HouseItemCategory.jsx
msgid "Ningún ítem la usa"
msgstr "Ningún ítem la usa"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "No hay recomendaciones"
msgstr "No hay recomendaciones"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "No hay tareas disponibles"
msgstr "No hay tareas disponibles"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "No repetir"
msgstr "No repetir"

#: src/pages/Economos/Search/EconomosSearchView.jsx
msgid "No se encontraron resultados"
msgstr "No se encontraron resultados"

#: src/pages/Recipes/RecipesView.jsx
msgid "No se han encontrado recetas"
msgstr "No se han encontrado recetas"

#: src/pages/Register/RegisterView.jsx
msgid "No se permite un email desechable"
msgstr "No se permite un email desechable"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "No se puede conectar con el servidor"
msgstr "No se puede conectar con el servidor"

#: src/utils/common/api/handleApiResponse.jsx
msgid "No tienes permisos para realizar esta acción"
msgstr "No tienes permisos para realizar esta acción"

#: src/components/Crew/CrewFields/CrewFields.jsx
#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
#: src/pages/Economos/Search/EconomosSearchView.jsx
#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Nombre"
msgstr "Nombre"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Nombre de la receta"
msgstr "Nombre de la receta"

#: src/pages/Register/RegisterView.jsx
msgid "Nombre de usuario"
msgstr "Nombre de usuario"

#: src/components/Crew/CrewFields/CrewFields.jsx
msgid "Nombre del espacio"
msgstr "Nombre del espacio"

#: src/pages/Items/tabs/Categories/HouseItemCategoryFields/HouseItemCategoryFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Nombre del ítem"
msgstr "Nombre del ítem"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Nombre requerido"
msgstr "Nombre requerido"

#: src/pages/Items/tabs/Categories/Categories.jsx
msgid "Nueva categoría"
msgstr "Nueva categoría"

#: src/pages/Recipes/RecipesView.jsx
msgid "Nueva receta"
msgstr "Nueva receta"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "Nueva tarea"
msgstr "Nueva tarea"

#: src/components/common/ui/badge/NewBadge.jsx
msgid "Nuevo"
msgstr "Nuevo"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Nuevo gasto"
msgstr "Nuevo gasto"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Nuevo grupo"
msgstr "Nuevo grupo"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Nuevo ítem"
msgstr "Nuevo ítem"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Nuevo movimiento"
msgstr "Nuevo movimiento"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Nuevo movimiento creado"
msgstr "Nuevo movimiento creado"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Nunca"
msgstr "Nunca"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "o"
msgstr "o"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
#: src/pages/Settings/Settings.jsx
msgid "Ocultar"
msgstr "Ocultar"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Operación:"
msgstr "Operación:"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Orden"
msgstr "Orden"

#: src/Layouts/private/partials/AppSelector.jsx
msgid "Organiza tus tareas del hogar. Crea listas, establece prioridades y nunca olvides lo que necesitas hacer."
msgstr "Organiza tus tareas del hogar. Crea listas, establece prioridades y nunca olvides lo que necesitas hacer."

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Origen"
msgstr "Origen"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Otros"
msgstr "Otros"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Pagado por"
msgstr "Pagado por"

#. placeholder {0}: expense.paidBy
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Pagado por <0>{0}</0>"
msgstr "Pagado por <0>{0}</0>"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "pagó"
msgstr "pagó"

#: src/pages/Onboarding/GroupView.jsx
msgid "para crear un espacio"
msgstr "para crear un espacio"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Para que un ítem desaparezca de esta lista, tendrás que marcarlo como"
msgstr "Para que un ítem desaparezca de esta lista, tendrás que marcarlo como"

#: src/pages/Recipes/partials/RecipeSteps/RecipeSteps.jsx
msgid "Paso"
msgstr "Paso"

#. placeholder {0}: i + 1
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Paso {0}"
msgstr "Paso {0}"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Pasos"
msgstr "Pasos"

#: src/pages/Register/RegisterView.jsx
msgid "pepeking66"
msgstr "pepeking66"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Periodo"
msgstr "Periodo"

#. placeholder {0}: item?.extendedProps?.recurrenceShortId
#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Pertenece a la serie: {0}"
msgstr "Pertenece a la serie: {0}"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Plan:"
msgstr "Plan:"

#: src/pages/Legal/TermsView.jsx
msgid "Podemos actualizar estos términos notificándotelo con antelación razonable; si continúas usando el servicio, se entienden aceptados. Puedes dejar de usar el servicio y eliminar tu cuenta en cualquier momento."
msgstr "Podemos actualizar estos términos notificándotelo con antelación razonable; si continúas usando el servicio, se entienden aceptados. Puedes dejar de usar el servicio y eliminar tu cuenta en cualquier momento."

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Podrás crear nuevas tareas personalizadas en cualquier momento"
msgstr "Podrás crear nuevas tareas personalizadas en cualquier momento"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Podrás crear nuevos ítems personalizados en cualquier momento"
msgstr "Podrás crear nuevos ítems personalizados en cualquier momento"

#: src/pages/Legal/CookiesView.jsx
msgid "Política de cookies"
msgstr "Política de cookies"

#: src/pages/Legal/PrivacyView.jsx
msgid "Política de privacidad"
msgstr "Política de privacidad"

#: src/pages/Economos/Movements/partials/EconomosListTabs/partials/EconomosListFields.jsx
msgid "Por ejemplo: \"sueldo\""
msgstr "Por ejemplo: \"sueldo\""

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Predicción"
msgstr "Predicción"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Predicción de gasto total"
msgstr "Predicción de gasto total"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Predicciones"
msgstr "Predicciones"

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Presente"
msgstr "Presente"

#: src/pages/Legal/PrivacyView.jsx
msgid "Prestar el servicio y gestionar tu cuenta: ejecución del contrato (art. 6.1.b RGPD)."
msgstr "Prestar el servicio y gestionar tu cuenta: ejecución del contrato (art. 6.1.b RGPD)."

#: src/pages/Legal/CookiesView.jsx
msgid "Prevenir ataques CSRF al enviar formularios."
msgstr "Prevenir ataques CSRF al enviar formularios."

#: src/pages/Onboarding/GroupView.jsx
msgid "Primero necesitas crear un espacio"
msgstr "Primero necesitas crear un espacio"

#: src/pages/Usage/UsageView.jsx
msgid "Primero selecciona un espacio."
msgstr "Primero selecciona un espacio."

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Productos del día a día"
msgstr "Productos del día a día"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Propietario"
msgstr "Propietario"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Proyección de gasto del mes"
msgstr "Proyección de gasto del mes"

#: src/pages/Legal/CookiesView.jsx
msgid "Puedes aceptar o rechazar en el aviso que aparece al entrar, con ambas opciones igual de accesibles."
msgstr "Puedes aceptar o rechazar en el aviso que aparece al entrar, con ambas opciones igual de accesibles."

#: src/pages/Legal/CookiesView.jsx
msgid "Puedes cambiar tu decisión en cualquier momento desde Ajustes → Cookies → Gestionar cookies."
msgstr "Puedes cambiar tu decisión en cualquier momento desde Ajustes → Cookies → Gestionar cookies."

#: src/pages/Legal/PrivacyView.jsx
msgid "Puedes consultar qué cookies utilizamos en nuestra <0>política de cookies</0>."
msgstr "Puedes consultar qué cookies utilizamos en nuestra <0>política de cookies</0>."

#: src/pages/Legal/PrivacyView.jsx
msgid "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a [PENDIENTE: privacy@…]. También puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es)."
msgstr "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a [PENDIENTE: privacy@…]. También puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es)."

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Puedes intentar recargar la página o cerrar sesión para limpiar los datos."
msgstr "Puedes intentar recargar la página o cerrar sesión para limpiar los datos."

#: src/pages/Onboarding/GroupView.jsx
msgid "Pulsa aquí"
msgstr "Pulsa aquí"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Quién hizo la tarea"
msgstr "Quién hizo la tarea"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Raciones"
msgstr "Raciones"

#: src/pages/Register/RegisterView.jsx
msgid "Rápido y sin contraseña: sólo tu email y tu nombre."
msgstr "Rápido y sin contraseña: sólo tu email y tu nombre."

#: src/components/common/ErrorBoundary/ErrorFallback.jsx
msgid "Recargar"
msgstr "Recargar"

#: src/pages/Recipes/RecipeDetail.jsx
#: src/pages/Recipes/RecipeShareView.jsx
msgid "Receta no encontrada"
msgstr "Receta no encontrada"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/AppSelector.jsx
msgid "Recetas"
msgstr "Recetas"

#: src/pages/Settings/Settings.jsx
msgid "Rechazadas"
msgstr "Rechazadas"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Rechazar"
msgstr "Rechazar"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Rechazar cookies"
msgstr "Rechazar cookies"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Recommendations.jsx
msgid "Recomendaciones"
msgstr "Recomendaciones"

#: src/pages/Legal/CookiesView.jsx
msgid "Recordar tu decisión sobre las cookies."
msgstr "Recordar tu decisión sobre las cookies."

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Reenviar email"
msgstr "Reenviar email"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Reenviar email ({resendIn}s)"
msgstr "Reenviar email ({resendIn}s)"

#: src/pages/Login/LoginView.jsx
msgid "Registrarse"
msgstr "Registrarse"

#: src/pages/Login/LoginView.jsx
msgid "Registrarte sólo te llevará 10 segundos."
msgstr "Registrarte sólo te llevará 10 segundos."

#: src/pages/Register/RegisterView.jsx
msgid "Registro"
msgstr "Registro"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Reintentar"
msgstr "Reintentar"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Renovar enlace de invitación"
msgstr "Renovar enlace de invitación"

#: src/pages/Repair/RepairView.jsx
msgid "Reparar"
msgstr "Reparar"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Repetir"
msgstr "Repetir"

#: src/pages/Economos/Movements/partials/EconomosRecurrenceSelector/EconomosRecurrenceSelector.jsx
msgid "Repetir hasta"
msgstr "Repetir hasta"

#: src/pages/Economos/Movements/partials/EconomosMonthBalance/EconomosMonthBalance.jsx
msgid "Restante:"
msgstr "Restante:"

#: src/pages/Mementos/tabs/Mementos/Mementos.jsx
msgid "Resto"
msgstr "Resto"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Resultado:"
msgstr "Resultado:"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Resumen por etiquetas"
msgstr "Resumen por etiquetas"

#: src/pages/Login/partials/MagicLinkStep.jsx
msgid "Revisa tu email"
msgstr "Revisa tu email"

#: src/components/Crew/CrewMembers/partials/CrewMember/CrewMember.jsx
msgid "Rol"
msgstr "Rol"

#: src/components/Crew/CrewMembers/CrewMembers.jsx
msgid "Rol cambiado con éxito"
msgstr "Rol cambiado con éxito"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Salir"
msgstr "Salir"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Salir del modo compra"
msgstr "Salir del modo compra"

#: src/pages/Items/tabs/Items/Items.jsx
msgid "Salir modo anclado"
msgstr "Salir modo anclado"

#: src/pages/Mementos/tabs/Mementos/partials/MementoItem/MementoItem.jsx
msgid "Se activa {childDelayDays}"
msgstr "Se activa {childDelayDays}"

#. placeholder {0}: daysSincePurchase ?? 0
#: src/pages/Items/tabs/Items/partials/HouseItem/partials/StockCountdown/StockCountdown.jsx
msgid "Se agota tras {outOfStockAfterDays}d · {0, plural, one {comprado hace # día} other {comprado hace # días}}"
msgstr "Se agota tras {outOfStockAfterDays}d · {0, plural, one {comprado hace # día} other {comprado hace # días}}"

#: src/pages/Repair/RepairView.jsx
msgid "Se intentará reparar cualquier problema que puedas tener con la aplicación.<0/>Ten en cuenta que se cerrará la sesión."
msgstr "Se intentará reparar cualquier problema que puedas tener con la aplicación.<0/>Ten en cuenta que se cerrará la sesión."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Se suele comprar cada {averageDays} días."
msgstr "Se suele comprar cada {averageDays} días."

#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Según la configuración de la lista, este movimiento inicia el mes"
msgstr "Según la configuración de la lista, este movimiento inicia el mes"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona"
msgstr "Selecciona"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Selecciona al menos una persona"
msgstr "Selecciona al menos una persona"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Selecciona el alcance de la eliminación. Esta acción no se puede deshacer."
msgstr "Selecciona el alcance de la eliminación. Esta acción no se puede deshacer."

#: src/components/common/ui/dates/Datepicker.jsx
msgid "Selecciona fecha"
msgstr "Selecciona fecha"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona la lista de destino"
msgstr "Selecciona la lista de destino"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Selecciona la lista de origen"
msgstr "Selecciona la lista de origen"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Selecciona otra tarea que active esta"
msgstr "Selecciona otra tarea que active esta"

#: src/pages/Mementos/tabs/MementosContributions/partials/ContributionFields/ContributionFields.jsx
msgid "Selecciona quién hizo la tarea"
msgstr "Selecciona quién hizo la tarea"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Selecciona quién pagó"
msgstr "Selecciona quién pagó"

#: src/pages/Settings/Settings.jsx
msgid "Selector de espacios siempre visible"
msgstr "Selector de espacios siempre visible"

#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Semana actual"
msgstr "Semana actual"

#: src/pages/Mementos/tabs/MementosContributions/MementosContributions.jsx
#: src/pages/Mementos/TasksDashboard/partials/TasksContributions/TasksContributions.jsx
msgid "Semana anterior"
msgstr "Semana anterior"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Semana en curso"
msgstr "Semana en curso"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
msgid "Serie eliminada"
msgstr "Serie eliminada"

#: src/pages/Legal/CookiesView.jsx
msgid "Sesión"
msgstr "Sesión"

#: src/App.jsx
msgid "Sesión expirada"
msgstr "Sesión expirada"

#: src/pages/Login/LoginView.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Sesión iniciada con éxito"
msgstr "Sesión iniciada con éxito"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Si eliges una tarea, esta se activará al completarla. Déjalo vacío para una tarea independiente."
msgstr "Si eliges una tarea, esta se activará al completarla. Déjalo vacío para una tarea independiente."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/EconomosMovementFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Si guardas, sobreescribirás sus cambios."
msgstr "Si guardas, sobreescribirás sus cambios."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Si no lo compras de nuevo, se marcará como agotado automáticamente."
msgstr "Si no lo compras de nuevo, se marcará como agotado automáticamente."

#: src/pages/Settings/Settings.jsx
msgid "Siempre"
msgstr "Siempre"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
#: src/pages/Items/tabs/Items/partials/HouseItemsShoppingMode/HouseItemsShoppingMode.jsx
msgid "Sin categoría"
msgstr "Sin categoría"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Sin datos"
msgstr "Sin datos"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "Sin datos de proyección"
msgstr "Sin datos de proyección"

#: src/pages/Economos/Dashboard/partials/DailyExpenseChart/DailyExpenseChart.jsx
msgid "Sin datos suficientes"
msgstr "Sin datos suficientes"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Sin gastos"
msgstr "Sin gastos"

#: src/pages/Economos/Dashboard/partials/CommonExpenses/CommonExpenses.jsx
msgid "Sin gastos este mes"
msgstr "Sin gastos este mes"

#: src/pages/SplitExpenses/SplitExpensesGroupView.jsx
msgid "Sin grupos"
msgstr "Sin grupos"

#: src/pages/Items/tabs/Items/partials/EmptyItems/EmptyItems.jsx
msgid "Sin ítems"
msgstr "Sin ítems"

#: src/pages/Economos/Movements/EconomosMovementsView.jsx
msgid "Sin movimientos"
msgstr "Sin movimientos"

#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Sin movimientos recientes"
msgstr "Sin movimientos recientes"

#: src/pages/Recipes/RecipesView.jsx
msgid "Sin recetas"
msgstr "Sin recetas"

#: src/pages/Settings/Settings.jsx
msgid "Sin responder"
msgstr "Sin responder"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagsSelector.jsx
msgid "Sin resultados"
msgstr "Sin resultados"

#: src/pages/SplitExpenses/partials/SplitExpenseFields.jsx
msgid "Sin usuarios"
msgstr "Sin usuarios"

#: src/pages/Settings/Settings.jsx
msgid "Solo el espacio actual"
msgstr "Solo el espacio actual"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Solo este movimiento"
msgstr "Solo este movimiento"

#: src/pages/Legal/CookiesView.jsx
msgid "Solo si aceptas, el servicio de diagnóstico de errores Bugsnag (EE. UU.) recibe datos de errores y rendimiento para detectar y corregir incidencias. Si rechazas o retiras el consentimiento, no se carga ni se envía nada a Bugsnag. Más detalles en nuestra <0>política de privacidad</0>."
msgstr "Solo si aceptas, el servicio de diagnóstico de errores Bugsnag (EE. UU.) recibe datos de errores y rendimiento para detectar y corregir incidencias. Si rechazas o retiras el consentimiento, no se carga ni se envía nada a Bugsnag. Más detalles en nuestra <0>política de privacidad</0>."

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Stock: {stockLabel}"
msgstr "Stock: {stockLabel}"

#. placeholder {0}: getActionableTagDisplayName(tagToRemove)
#: src/pages/Economos/Movements/partials/EconomosItem/EconomosItem.jsx
msgid "Tag '{0}' eliminado"
msgstr "Tag '{0}' eliminado"

#: src/pages/Legal/CookiesView.jsx
msgid "También puedes bloquear o eliminar cookies desde la configuración de tu navegador."
msgstr "También puedes bloquear o eliminar cookies desde la configuración de tu navegador."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Tarea activadora"
msgstr "Tarea activadora"

#: src/components/common/UsageLimit/usageUtils.jsx
#: src/Layouts/private/partials/AppSelector.jsx
#: src/pages/Usage/UsageView.jsx
msgid "Tareas"
msgstr "Tareas"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Te han invitado a formar parte de"
msgstr "Te han invitado a formar parte de"

#: src/pages/Legal/CookiesView.jsx
msgid "Técnica (exenta)"
msgstr "Técnica (exenta)"

#: src/pages/Legal/TermsView.jsx
msgid "Términos y condiciones"
msgstr "Términos y condiciones"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Tiempo"
msgstr "Tiempo"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Tiempo que pasa desde que la tarea activadora se completa hasta que esta tarea se activa."
msgstr "Tiempo que pasa desde que la tarea activadora se completa hasta que esta tarea se activa."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/TagSelectorUncomittedTagWarning.jsx
msgid "Tienes etiquetas sin añadir"
msgstr "Tienes etiquetas sin añadir"

#: src/pages/Legal/CookiesView.jsx
msgid "Tipo"
msgstr "Tipo"

#: src/pages/Onboarding/GroupView.jsx
msgid "Toda la información que almacenes se hará en el espacio seleccionado, de esta forma podrás separar (por ejemplo) \"Personal\" de \"Familia\"."
msgstr "Toda la información que almacenes se hará en el espacio seleccionado, de esta forma podrás separar (por ejemplo) \"Personal\" de \"Familia\"."

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "Todavía no hay predicciones"
msgstr "Todavía no hay predicciones"

#: src/pages/Mementos/TasksDashboard/partials/AllTasksDone/AllTasksDone.jsx
msgid "Todo en paz"
msgstr "Todo en paz"

#: src/pages/Home/HomeView.jsx
msgid "Todo lo que tu hogar necesita,<0/>en un solo lugar"
msgstr "Todo lo que tu hogar necesita,<0/>en un solo lugar"

#: src/components/common/ui/input/GroupedSelection/GroupedSelection.jsx
msgid "Todos"
msgstr "Todos"

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/DeleteMovementWithRecurrenceConfirmation.jsx
msgid "Todos los de la serie"
msgstr "Todos los de la serie"

#: src/pages/Settings/Settings.jsx
msgid "Todos mis espacios"
msgstr "Todos mis espacios"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Total"
msgstr "Total"

#. placeholder {0}: totalExpenses.toFixed(2)
#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "Total gasto: {0} €"
msgstr "Total gasto: {0} €"

#: src/pages/Legal/TermsView.jsx
msgid "Trabajamos por ofrecer un servicio continuo, pero no garantizamos disponibilidad ininterrumpida ni ausencia de errores. En la máxima medida permitida por la ley, la responsabilidad se limita a los daños directos probados y, en ningún caso, a cantidades superiores a lo que hubieras pagado por el servicio en los 12 meses previos. Nada de lo aquí dispuesto excluye responsabilidades que no puedan limitarse por ley."
msgstr "Trabajamos por ofrecer un servicio continuo, pero no garantizamos disponibilidad ininterrumpida ni ausencia de errores. En la máxima medida permitida por la ley, la responsabilidad se limita a los daños directos probados y, en ningún caso, a cantidades superiores a lo que hubieras pagado por el servicio en los 12 meses previos. Nada de lo aquí dispuesto excluye responsabilidades que no puedan limitarse por ley."

#: src/pages/Economos/Movements/EconomosMovementsView.jsx
#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Transferencia"
msgstr "Transferencia"

#: src/pages/Economos/Movements/partials/EconomosTransferFields/EconomosTransferFields.jsx
msgid "Transferencia creada"
msgstr "Transferencia creada"

#: src/pages/Login/LoginView.jsx
msgid "Tras iniciar sesión, te llevaremos a tu invitación."
msgstr "Tras iniciar sesión, te llevaremos a tu invitación."

#: src/pages/Login/LoginView.jsx
msgid "Tras iniciar sesión, te llevaremos de vuelta."
msgstr "Tras iniciar sesión, te llevaremos de vuelta."

#: src/pages/Register/RegisterView.jsx
msgid "Tras registrarte, te llevaremos a tu invitación."
msgstr "Tras registrarte, te llevaremos a tu invitación."

#: src/pages/Register/RegisterView.jsx
msgid "Tras registrarte, te llevaremos de vuelta."
msgstr "Tras registrarte, te llevaremos de vuelta."

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "ud, g, ml..."
msgstr "ud, g, ml..."

#: src/pages/Legal/LegalPage.jsx
msgid "Última actualización: 26/08/2026"
msgstr "Última actualización: 26/08/2026"

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
msgid "Última vez"
msgstr "Última vez"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 10 años"
msgstr "Últimos 10 años"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 2 días"
msgstr "Últimos 2 días"

#: src/pages/Economos/Search/partials/DaterangeShortcuts/DaterangeShortcuts.jsx
msgid "Últimos 7 días"
msgstr "Últimos 7 días"

#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Últimos movimientos"
msgstr "Últimos movimientos"

#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Una descripción breve"
msgstr "Una descripción breve"

#: src/pages/Settings/Settings.jsx
msgid "Una tarea inactiva no se podrá completar hasta que se active, pasado el tiempo configurado."
msgstr "Una tarea inactiva no se podrá completar hasta que se active, pasado el tiempo configurado."

#: src/pages/Mementos/tabs/Mementos/partials/MementoFields/MementoFields.jsx
#: src/pages/Recipes/partials/RecipeFields/RecipeFields.jsx
msgid "Unidad"
msgstr "Unidad"

#: src/pages/Items/tabs/Categories/HouseItemCategory/HouseItemCategory.jsx
msgid "Usada en {houseItemCount, plural, one {# ítem} other {# ítems}}"
msgstr "Usada en {houseItemCount, plural, one {# ítem} other {# ítems}}"

#: src/components/common/CookieConsentBanner/CookieConsentBanner.jsx
msgid "Usamos cookies técnicas para que la app funcione y, solo si lo aceptas, cookies de diagnóstico de errores. <0>Más información</0>"
msgstr "Usamos cookies técnicas para que la app funcione y, solo si lo aceptas, cookies de diagnóstico de errores. <0>Más información</0>"

#: src/components/common/ui/combobox/HouseItemCombobox.jsx
msgid "Usar"
msgstr "Usar"

#. placeholder {0}: usageItem.limit
#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Usarías {wouldUse}/{0} ítems de tu plan actual"
msgstr "Usarías {wouldUse}/{0} ítems de tu plan actual"

#. placeholder {0}: usageTask.limit
#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Usarías {wouldUse}/{0} tareas de tu plan actual"
msgstr "Usarías {wouldUse}/{0} tareas de tu plan actual"

#: src/pages/Usage/UsageView.jsx
msgid "Uso del plan"
msgstr "Uso del plan"

#: src/pages/Items/tabs/Items/partials/HouseItemFields/HouseItemFields.jsx
msgid "Uso único"
msgstr "Uso único"

#: src/Layouts/private/partials/UserInfo.jsx
msgid "Usuario: "
msgstr "Usuario: "

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Usuarios"
msgstr "Usuarios"

#: src/pages/Legal/PrivacyView.jsx
msgid "Utilizamos Bugsnag, Inc. (EE. UU.) como procesador de datos de diagnóstico de errores, únicamente si has aceptado las cookies no exentas. Dicha transferencia está amparada en las cláusulas contractuales tipo aprobadas por la Comisión Europea (decisión de ejecución 2021/914) y en el acuerdo de tratamiento de datos (DPA) suscrito con el proveedor."
msgstr "Utilizamos Bugsnag, Inc. (EE. UU.) como procesador de datos de diagnóstico de errores, únicamente si has aceptado las cookies no exentas. Dicha transferencia está amparada en las cláusulas contractuales tipo aprobadas por la Comisión Europea (decisión de ejecución 2021/914) y en el acuerdo de tratamiento de datos (DPA) suscrito con el proveedor."

#: src/pages/MagicLink/MagicLink.jsx
msgid "Validando..."
msgstr "Validando..."

#: src/pages/Economos/Movements/partials/EconomosMovementFields/partials/Calculator.jsx
msgid "Valor inicial:"
msgstr "Valor inicial:"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor máximo"
msgstr "Valor máximo"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor medio"
msgstr "Valor medio"

#: src/pages/Economos/Movements/partials/MovementAnalysis/MovementAnalysis.jsx
msgid "Valor mínimo"
msgstr "Valor mínimo"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver más"
msgstr "Ver más"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver menos"
msgstr "Ver menos"

#: src/pages/Economos/Movements/partials/EconomosSummaryByTags/EconomosSummaryByTags.jsx
msgid "Ver resumen"
msgstr "Ver resumen"

#: src/pages/Mementos/TasksDashboard/TasksDashboard.jsx
msgid "Ver tareas"
msgstr "Ver tareas"

#: src/pages/Economos/Dashboard/EconomosMovementsDashboard.jsx
#: src/pages/Economos/Dashboard/partials/RecentMovements.jsx
msgid "Ver todos"
msgstr "Ver todos"

#: src/components/common/ErrorBoundary/ErrorServer.jsx
msgid "Verifica tu conexión a internet e inténtalo de nuevo."
msgstr "Verifica tu conexión a internet e inténtalo de nuevo."

#: src/components/auth/HumanVerification/HumanVerification.jsx
msgid "Verificación humana"
msgstr "Verificación humana"

#: src/pages/SplitExpenses/partials/SplitExpenseGroupFields.jsx
msgid "Viaje, cena, piso..."
msgstr "Viaje, cena, piso..."

#: src/pages/Economos/Movements/partials/EconomosDateSelector/EconomosDateSelector.jsx
msgid "Volver a hoy"
msgstr "Volver a hoy"

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Volver a la app"
msgstr "Volver a la app"

#: src/pages/Login/partials/MagicLinkStep.jsx
#: src/pages/MagicLink/MagicLink.jsx
msgid "Volver al login"
msgstr "Volver al login"

#: src/pages/Economos/Dashboard/partials/DailyExpenseCard.jsx
msgid "vs mes anterior"
msgstr "vs mes anterior"

#: src/pages/SplitExpenses/SplitExpensesView.jsx
msgid "y debe"
msgstr "y debe"

#: src/pages/Items/tabs/Predictions/Predictions.jsx
msgid "y que deberían haberse comprado, aparecerán en esta lista para ayudarte a tener los stocks al día."
msgstr "y que deberían haberse comprado, aparecerán en esta lista para ayudarte a tener los stocks al día."

#: src/pages/CrewInvitation/CrewInvitationView.jsx
msgid "Ya eres miembro de este espacio"
msgstr "Ya eres miembro de este espacio"

#: src/pages/Onboarding/GroupView.jsx
msgid "Ya puedes empezar a usar todos los módulos:"
msgstr "Ya puedes empezar a usar todos los módulos:"

#: src/pages/Home/HomeView.jsx
msgid "Ya tengo cuenta"
msgstr "Ya tengo cuenta"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes esta tarea"
msgstr "Ya tienes esta tarea"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes este ítem en la despensa"
msgstr "Ya tienes este ítem en la despensa"

#: src/pages/Mementos/tabs/Mementos/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes todas esas tareas"
msgstr "Ya tienes todas esas tareas"

#: src/pages/Items/tabs/Items/partials/InitialSetupModal/InitialSetupModal.jsx
msgid "Ya tienes todos esos ítems"
msgstr "Ya tienes todos esos ítems"
